import { ExternalLink } from 'lucide-react'

import { Anchor } from '@/components/ui/Anchor'
import { Badge } from '@/components/ui/badge'
import type { EldConnection } from '@/models/user'

/** Square radius and the same height, so it reads as a set with the status pill and Notes beside it. */
const PILL = 'h-7 rounded-sm'

/** Whether a customer's ELD is linked — and, when it is, a way into Terminal. */
export function EldStatusPill({ eld }: { eld: EldConnection | undefined }) {
  if (!eld?.connected) {
    return (
      <Badge variant="secondary" className={PILL}>
        ELD not connected
      </Badge>
    )
  }

  const body = (
    <>
      {eld.providerIconUrl && (
        <img
          src={eld.providerIconUrl}
          alt=""
          // Terminal's marks are near-black on transparent, so they need a light chip to sit on.
          className="size-3.5 rounded-[3px] bg-white object-contain p-px"
        />
      )}
      {eld.providerName ? `ELD connected · ${eld.providerName}` : 'ELD connected'}
    </>
  )

  if (!eld.dashboardUrl) {
    return (
      <Badge variant="success" className={PILL}>
        {body}
      </Badge>
    )
  }

  return (
    <Anchor href={eld.dashboardUrl} target="_blank" rel="noopener noreferrer" title="Open in Terminal">
      <Badge variant="success" className={`${PILL} hover:bg-green-600`}>
        {body}
        <ExternalLink />
      </Badge>
    </Anchor>
  )
}
